import { Collapse } from '@mui/material';
import { Size } from '@ps/web-core-enums';
import { useScreenSize } from '@ps/web-shared-components';
import { StarsLink } from '@ps/web-shared-ui';
import classNames from 'clsx';
import type { FC, ReactElement } from 'react';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import ArrowIcon from '@swf/core/assets/icons/arrow.svg';

import { useCashierWidget } from '../../../../model';

import style, { arrow, iconContainer, link } from './CollapseButton.scss';
import CollapseButtonLabel from './components/CollapseButtonLabel/CollapseButtonLabel';

interface CollapseButtonProps {
  startIcon?: ReactElement;
  endIcon?: ReactElement;
}

const CollapseButton: FC<React.PropsWithChildren<CollapseButtonProps>> = ({
  startIcon,
  children
}) => {
  const { widgetSelect } = useCashierWidget();
  const closestLimits = useSelector(widgetSelect.getClosestLimit);
  const { overallClosest } = closestLimits;
  const [expand, setExpand] = useState(false);
  const { greaterThan } = useScreenSize();

  return (
    <div data-testid="collapse-button">
      <StarsLink className={link} onClick={() => setExpand(!expand)}>
        {startIcon && <div className={iconContainer}>{startIcon}</div>}
        <CollapseButtonLabel overallClosestLimit={overallClosest} />
        {!greaterThan(Size.XXSmall) && (
          <div className={classNames(iconContainer, arrow)}>
            <ArrowIcon className={classNames({ [style.icon]: expand })} />
          </div>
        )}
      </StarsLink>
      <Collapse in={!greaterThan(Size.XXSmall) ? expand : true}>{children}</Collapse>
    </div>
  );
};

export default CollapseButton;
